import axios from 'axios'

function unwrapList(res) {
  const d = res?.data ?? res
  if (!d) return []
  if (Array.isArray(d)) return d
  if (Array.isArray(d.data)) return d.data
  if (Array.isArray(d.rows)) return d.rows
  if (Array.isArray(d.items)) return d.items
  return []
}

function unwrapOne(res) {
  const d = res?.data ?? res
  if (!d) return null
  if (d.data && typeof d.data === 'object') return d.data
  return d
}

const MeetingsService = {
  async list(params = {}) {
    return axios.get('meetings', { params })
  },

  async get(id) {
    if (!id) throw new Error('Missing meeting id')
    return axios.get(`meetings/${encodeURIComponent(id)}`)
  },

  async create(payload = {}) {
    return axios.post('meetings', payload)
  },

  async update(id, payload = {}) {
    if (!id) throw new Error('Missing meeting id')
    return axios.put(`meetings/${encodeURIComponent(id)}`, payload)
  },

  async destroy(id) {
    if (!id) throw new Error('Missing meeting id')
    return axios.delete(`meetings/${encodeURIComponent(id)}`)
  },

  async getToken(id) {
    if (!id) throw new Error('Missing meeting id')
    return axios.post(`meetings/${encodeURIComponent(id)}/token`)
  },

  async invite(id, userId) {
    if (!id) throw new Error('Missing meeting id')
    return axios.post(`meetings/${encodeURIComponent(id)}/invite`, { user_id: userId })
  },

  async directCall(targetUserId) {
    return axios.post('meetings/direct-call', { target_user_id: targetUserId })
  },

  async getWaiting(id) {
    if (!id) throw new Error('Missing meeting id')
    return axios.get(`meetings/${encodeURIComponent(id)}/waiting`)
  },

  async admitParticipant(meetingId, participantId) {
    return axios.post(`meetings/${encodeURIComponent(meetingId)}/admit/${encodeURIComponent(participantId)}`)
  },

  unwrapList,
  unwrapOne
}

export default MeetingsService
